import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FaSave, FaTimes } from "react-icons/fa";
import OtpInput from "./OtpInput"; // Import the OtpInput component

const ChangeEmailModal = ({
  show,
  onHide,
  onSave,
  onRequestOtp, // Function to call parent's OTP request logic
  otp,
  setOtp,
  newEmail,
  setNewEmail,
  otpRequested, // Flag from parent indicating if OTP step is active
  setOtpRequested, // Function to update parent's otpRequested state if needed
  otpSuccessMessage, // Flag from parent indicating OTP sent successfully
}) => {

  const handleRequestOtpClick = () => {
    // Call the parent's OTP request function, specifying the type
    onRequestOtp("email");
  };

   const handleRequestNewOtp = () => {
    setOtpRequested(false); // Signal parent to reset OTP state for a new request
    // Parent's handleEditClick('email', ...) or handleOtpRequest should handle resetting fields
  };

  const handleCancel = () => {
    // Let the parent handle state reset on hide
    onHide();
  };

  const handleSaveClick = () => {
    onSave(); // Call the save handler passed from parent
  };

  // Basic email validation regex
  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  // Disable save if OTP isn't 6 digits or email is invalid
  const isSaveDisabled = otp.join("").length !== 6 || !isValidEmail(newEmail);

  return (
    // Prevent closing on backdrop click or Esc when OTP is requested
    <Modal show={show} onHide={handleCancel} centered backdrop={otpRequested ? "static" : true} keyboard={!otpRequested}>
      {/* Hide close button during OTP entry */}
      <Modal.Header closeButton={!otpRequested}>
        <Modal.Title>Change Email</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!otpRequested ? (
          // Initial view: Prompt to request OTP
          <div>
            <p>
              To change your email, we need to verify your identity.
              Click below to send a One-Time Password (OTP) to your current registered email.
            </p>
             {/* Buttons moved to footer */}
          </div>
        ) : (
          // OTP view: Show OTP input and new email field
          <Form onSubmit={(e) => { e.preventDefault(); if (!isSaveDisabled) handleSaveClick(); }}> {/* Allow submitting with Enter */}
            {otpSuccessMessage && (
              <p className="text-success text-center mb-3">
                OTP sent successfully. Please check your current email and enter it below.
              </p>
            )}
            <OtpInput
              otp={otp}
              setOtp={setOtp}
              onResendOtp={handleRequestNewOtp} // Pass the function to allow requesting new OTP
            />
            <Form.Group controlId="formNewEmailInput">
              <Form.Label>New Email Address</Form.Label>
              <Form.Control
                type="email"
                value={newEmail}
                onChange={(e) => setNewEmail(e.target.value)}
                placeholder="Enter new email address"
                required
                isInvalid={newEmail.length > 0 && !isValidEmail(newEmail)} // Show invalid feedback only after typing
                autoFocus // Focus email field after OTP entry
              />
               <Form.Control.Feedback type="invalid">
                Please enter a valid email address.
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        )}
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between"> {/* Added flex justify */}
         {!otpRequested ? (
            // Initial state: Show Cancel and Request OTP buttons
            <>
                <Button variant="outline-secondary" onClick={handleCancel}> {/* Changed variant */}
                    <FaTimes className="me-1" /> Cancel
                </Button>
                <Button variant="primary" onClick={handleRequestOtpClick}>
                    Request OTP
                </Button>
            </>
        ) : (
            // OTP Requested state: Show Cancel and Save buttons
            <>
                <Button variant="outline-secondary" onClick={handleCancel}> {/* Changed variant */}
                    <FaTimes className="me-1" /> Cancel
                </Button>
                <Button variant="primary" onClick={handleSaveClick} disabled={isSaveDisabled}>
                    <FaSave className="me-1" /> Save Email
                </Button>
            </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ChangeEmailModal;
